import PdfGenerator from '../components/pdf-generator/javascripts/index';

const generators = document.querySelectorAll('.pdf-generator');

generators.forEach((element) => PdfGenerator(element).init());
